//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

export default function DragOverlayDragIcon({ icon }) {
  return (
    <span className={`material-icons ${myStyles.dragOverlayIcon}`}>
      {icon ?? "drag_indicator"}
    </span>
  )
}
